module.exports = __webpack_public_path__ + "img/label-OV.c4e7d834.png";